export default __webpack_public_path__ + "static/award-2023-III-023d0368247cf65ebde304eb8c87bf00.png";